import { AuditLog, PaginatedAuditLogsResponse } from "@/contracts/auth-api.types";
import { apiRequest } from "./apiClient";

export interface AuditLogQueryParams {
  user_id?: string;
  user_name?: string;
  page?: number;
  limit?: number;
}

export const auditLogService = {
  /**
   * Lista logs de auditoria com filtros opcionais de usuário e paginação.
   */
  async list(params: AuditLogQueryParams = {}): Promise<PaginatedAuditLogsResponse | AuditLog[]> {
    const searchParams = new URLSearchParams();
    if (params.user_id) searchParams.set("user_id", params.user_id);
    if (params.user_name) searchParams.set("user_name", params.user_name);
    if (params.page) searchParams.set("page", String(params.page));
    if (params.limit) searchParams.set("limit", String(params.limit));

    const qs = searchParams.toString();
    const url = qs ? `/audit-logs?${qs}` : "/audit-logs";
    return await apiRequest<PaginatedAuditLogsResponse | AuditLog[]>(url);
  },
};
